export default __webpack_public_path__ + "static/get-your-free-score-077a48eeed5aabfcffb4ce2280b5ecb1.svg";